import React, {Component} from 'react'
import {object} from 'prop-types'
import {Provider} from 'react-redux'

import AppContainer from 'shell/AppContainer'

export default class Root extends Component {
    static propTypes = {
        store: object.isRequired
    }

    render() {
        const {store} = this.props
        return (
            <Provider store={store}>
                <AppContainer/>
            </Provider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/shell/Root.prod.js